document.addEventListener("DOMContentLoaded", () => {

  const container = document.getElementById("confetti-container");
  if (!container) return;
  const durationSeconds = Number(container.dataset.confettiDuration);
  const durationMs = durationSeconds * 1000;

  const colors = [
    "#fce18a",
    "#ff726d",
    "#b48def",
    "#f4306d"
  ];

  const speeds = ["slow", "medium", "fast"];

  const createConfetti = () => {
    const confetti = document.createElement("div");

    confetti.classList.add("confetti");
    confetti.classList.add(
      speeds[Math.floor(Math.random() * speeds.length)]
    );

    confetti.style.left = Math.random() * 100 + "vw";
    confetti.style.backgroundColor =
      colors[Math.floor(Math.random() * colors.length)];

    container.appendChild(confetti);

    setTimeout(() => {
      confetti.remove();
    }, 3000);
  };

  const interval = setInterval(createConfetti, 40);

  setTimeout(() => {
    clearInterval(interval);
  }, durationMs);

});